export enum PlateType{
	PLATE="PLATE",ARRAY="ARRAY",BATCH="BATCH",PLATE_BATCH="PLATE_BATCH"
}